export default function PRABaseController(
  userService
) {
  const vm = this;

  console.log('app.components.advisory.pra.praBaseController created');

  /** ********************************
   * Public API
   */

  vm.initPermissions = _initPermissions;

  /** ********************************
   * Private Functions
   */

  function _initPermissions() {
    return userService.getUserPermissionSet('policyRiskAssessment').then((permissions) => {
      vm.permissions = permissions;
    });
  }
}
